/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Broker_DownInputs */

const vi_error_irrigation_broker_down = /** @type {(inputs: Error_Irrigation_Broker_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SmartLab đang mất kết nối tới thiết bị nên lệnh chưa được gửi. Thử lại sau ít phút.`)
};

/**

* @param {Error_Irrigation_Broker_DownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_broker_down = /** @type {((inputs?: Error_Irrigation_Broker_DownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Broker_DownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_broker_down(inputs)
});